@if (!isHidden()) {
    @if (displayMode === "Kanban" || displayMode === "details") {
        <div
            class="wk-ckd__container"
            [class.not-assigned]="displayMode === 'details' && (isUnassigned(columnData().assignedUserId) || columnData().active !== true)"
            [class.expanded]="expanded()"
            [class.hovering]="hovering()"
            [class.dragging]="dragging()"
            (mouseenter)="onColumnHover()"
            (mouseleave)="onColumnHoverEnd()"
        >
            <div class="wk-ckd__header">
                <div id="columnName_{{ columnData().id }}" class="wk-ckd__header-title truncate">
                    {{ columnData().columnName | wkTranslate }}

                    @if ((columnData().columnName | wkTranslate)?.length >= 18) {
                        <portal-pds3 elementId="wk-app__root">
                            <tooltip-pds3 targetSelector="#columnName_{{ columnData().id }}" position="top" [closeDelay]="100" [openDelay]="500">
                                {{ columnData().columnName | wkTranslate }}
                            </tooltip-pds3>
                        </portal-pds3>
                    }
                </div>

                <i
                    [class.left]="expanded() || (hovering() && dragging())"
                    [class.right]="!(expanded() || (hovering() && dragging()))"
                    class="wk-ckd__header-icon"
                    (click)="toggleColumnWidth()"
                ></i>

                <div class="wk-ckd__header-counter">
                    {{ clientFileCount() }}
                </div>
            </div>
            <div class="wk-ckd__content">
                <div
                    class="wk-ckd__status-list"
                    [class.dragging]="dragging()"
                    [class.hovering]="hovering()"
                    [class.expanded]="expanded()"
                    [id]="'drag-' + columnData().id"
                >
                    @for (status of statuses(); track status.Id) {
                        <wk-drop-list
                            groupId="cardStatuses"
                            [id]="'drop_list_status_' + status.Id"
                            class="wk-ckd__status-drop-zone wk-drop-list--dashed"
                            [cdkDropListSortingDisabled]="true"
                            [cdkDropListDisabled]="disabledDropListIds().has(status.Id)"
                            (drop)="onDrop($event, status.Id, columnData().assignedUserId)"
                        >
                            <span class="wk-ckd__status-label">
                                @if (displayMode === "details") {
                                    {{ columnData().columnName | wkTranslate }}
                                } @else {
                                    {{ status.Name | wkTranslate }}
                                }
                            </span>
                            @if (unavailableStatusIds().has(status.Id)) {
                                <div class="wk-ckd__status-unavailable-message">{{ "JobsAndBilling.JobStatusUnavailable" | wkTranslate }}</div>
                            }
                        </wk-drop-list>
                    }

                    @if (!statuses()?.length) {
                        <wk-drop-list
                            groupId="cardStatuses"
                            [id]="'drop_list_status_empty' + columnData().id"
                            class="wk-ckd__status-drop-zone wk-ckd__status-drop-zone--empty"
                            [cdkDropListSortingDisabled]="true"
                            [cdkDropListDisabled]="true"
                            (drop)="onDrop($event, '', '')"
                        >
                            {{ "ViewComponent.NoDragStatus" | translate }}
                        </wk-drop-list>
                    }
                </div>
                <wk-drop-list
                    groupId="cardStatuses"
                    [id]="'drop_list_' + columnData().id"
                    [cdkDropListSortingDisabled]="true"
                    class="wk-ckd__cards-list"
                    [class.dragging]="dragging()"
                >
                    @if (expanded() && cards().length > 0) {
                        <cdk-virtual-scroll-viewport
                            #scrollActiveColumns
                            itemSize="109"
                            class="fancy-scrollbar"
                            [class.has-scrollbar]="hasScrollbar()"
                            [ngStyle]="{
                                'height.px': containerHeight(),
                            }"
                        >
                            <div *cdkVirtualFor="let card of cards(); trackBy: trackByCardId">
                                @if (!dragging() || dragOriginalCardId() === card.cardId) {
                                    <div class="wk-ckd__card-wrapper">
                                        <wk-drag
                                            [cdkDragData]="card"
                                            [cdkDragDisabled]="dragDisabled() || disabledDragCardIds().has(card.cardId)"
                                            (dragAttempted)="onDragAttemptedWhileDisabled()"
                                        >
                                            @if (isJobsBillingDashboard()) {
                                                <wk-card-jobs-billing
                                                    [cardData]="card"
                                                    [statusIds]="statusIds()"
                                                    [dragDisabled]="dragDisabled() || disabledDragCardIds().has(card.cardId)"
                                                />
                                            } @else {
                                                <wk-card-t1
                                                    [cardData]="card"
                                                    [columnData]="columnData()"
                                                    [statusIds]="statusIds()"
                                                    [columnId]="columnData().id"
                                                    [format]="'column'"
                                                    [hideArrows]="false"
                                                />
                                            }
                                            <ng-template *wkDragPlaceholder></ng-template>
                                        </wk-drag>
                                    </div>
                                }
                            </div>
                        </cdk-virtual-scroll-viewport>
                    }
                </wk-drop-list>
            </div>
        </div>
    }

    @if (displayMode === "List") {
        <div class="wk-cl__container">
            @if (cards().length === 0) {
                <div class="wk-cl__no-info">{{ "ViewComponent.NoInfo" | translate }}</div>
            }
            <cdk-virtual-scroll-viewport
                #scrollActiveColumns
                itemSize="39"
                class="fancy-scrollbar-gray"
                [class.has-scrollbar]="hasScrollbar()"
                [class.stable-scrollbar-gutter]="scrollbarGutterStable()"
            >
                <div *cdkVirtualFor="let card of cards(); trackBy: trackByCardId">
                    <div class="row table-row column-grid-format-row">
                        @if (isJobsBillingDashboard()) {
                            <wk-card-jobs-billing [cardData]="card" [statusIds]="statusIds()" [format]="'grid'" />
                        } @else {
                            <wk-card-t1
                                [cardData]="card"
                                [columnData]="columnData()"
                                [statusIds]="statusIds()"
                                [columnId]="columnData().id"
                                [format]="'grid'"
                                [hideArrows]="false"
                            />
                        }
                    </div>
                </div>
            </cdk-virtual-scroll-viewport>
        </div>
    }
}
